/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".support-email-footer[_ngcontent-%COMP%]{font-size:105%;margin-bottom:5px}\n/*# sourceMappingURL=footer.component.css.map*/"];
export { styles as styles };
